/*eslint-disable */
define(function (require) {
    var $ = require('jquery');
            require('jquery-validate');

    $.validator.addMethod('regexp', function (value, element, param) {
        return this.optional(element) || value.match(param);
    });
});
